import { Category, CATEGORY_INFO } from "@/lib/rules";

const COLOR: Record<Category, string> = {
  I: "#35C48A",
  II: "#5FB6E8",
  III: "#F2A93B",
  IV: "#E8563D",
};

export function CategoryBadge({ category, showWeight = true }: { category: Category; showWeight?: boolean }) {
  const info = CATEGORY_INFO[category];
  const color = COLOR[category];
  return (
    <span
      className="inline-flex items-center gap-1.5 rounded-sm border px-2 py-0.5 font-mono text-[11px] tracking-wide"
      style={{ borderColor: color + "55", color, background: color + "14" }}
      title={`${info.label} — ${info.rule}`}
    >
      <span className="h-1.5 w-1.5 rounded-full" style={{ background: color }} />
      CAT {category}
      {showWeight && <span className="text-[10px] opacity-70">· {info.weight}</span>}
    </span>
  );
}
